import { render } from "./Statement.vue?vue&type=template&id=2b925c18&scoped=true"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=2b925c18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b925c18"

export default script